/** Euros in the browser's own formatting; "—" for an unknown (G-204: one copy for the home page's parts). */
export const eur = (v: string | number | null | undefined): string => {
  const n = v == null ? NaN : Number(v);
  return Number.isFinite(n) ? n.toLocaleString(undefined, { style: "currency", currency: "EUR" }) : "—";
};

/** "09:00" from an instant, in the browser's own clock. */
export const hhmm = (iso: string): string =>
  new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
